<template>
  <div>
    <b-table :items="precedence"></b-table>
  </div>
</template>

<script>

export default {
  data () {
    return {
      precedence: [
        {operators: '()   []   ->   .   ::', description: 'Function call, scope, array/member access'},
        {operators: '!   ~   -   +   *   &   sizeof   type cast   ++   --', description: '(most) unary operators, sizeof and type casts (right to left)'},
        {operators: '*   /   % MOD', description: 'Multiplication, division, modulo'},
        {operators: '+   -', description: 'Addition and subtraction'},
        {operators: '<<   >>', description: 'Bitwise shift left and right'},
        {operators: '<   <=   >   >=', description: 'Comparisons: less-than and greater-than'},
        {operators: '==   !=', description: 'Comparisons: equal and not equal'},
        {operators: '&', description: 'Bitwise AND'},
        {operators: '^', description: 'Bitwise exclusive OR (XOR)'},
        {operators: '|', description: 'Bitwise inclusive (normal) OR'},
        {operators: '&&', description: 'Logical AND'},
        {operators: '||', description: 'Logical OR'},
        {operators: '? :', description: 'Conditional expression (ternary)'},
        {operators: '=   +=   -=   *=   /=   %=   &=   |=   ^=   <<=   >>=', description: 'Assignment operators (right to left)'},
        {operators: ',', description: 'Comma operator'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/precedence.vue